/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import Measure from 'react-measure';
import { getUnixDate } from '../../../../modules/datetime';
import { pureWithState } from '../../../../src/web/utils/react';
import CurrentPageContext from '../../../contexts/CurrentPageContext';
import Date from '../../stateless/Date';
import StarRack from '../../stateless/StarRack';
import Translation from '../../stateless/Translation';
import gIcon from './g-icon.svg';
import style from './Review.scss';

class Review extends React.Component {
  static propTypes = {
    author: PropTypes.string,
    date: PropTypes.string,
    rating: PropTypes.number.isRequired,
    body: PropTypes.string,
    googleReview: PropTypes.bool,
  };

  static defaultProps = {
    author: undefined,
    date: undefined,
    body: undefined,
    googleReview: undefined,
  };

  static contextType = CurrentPageContext;

  state = {
    dimensions: {
      height: 0,
    },
    page: 0,
  };

  getTotalPages() {
    const { dimensions } = this.state;
    if (!dimensions.height || !this.reviewBody) {
      return 0;
    }

    const { scrollHeight } = this.reviewBody;
    return Math.max(
      Math.ceil(scrollHeight / dimensions.height),
      0,
    );
  }

  handleRevealClick = () => {
    const totalPages = this.getTotalPages();
    if (totalPages === 0) {
      return;
    }

    this.setState(({ page }) => ({
      page: page >= totalPages - 1 ? 0 : page + 1,
    }));
  };

  registerReviewBody = (reviewBody) => {
    this.reviewBody = reviewBody;
  };

  renderRevealButton() {
    const { secondaryColorClass } = this.context;
    const totalPages = this.getTotalPages();
    if (totalPages <= 1) {
      return false;
    }
    const { page } = this.state;

    const messageProps = page === totalPages - 1
      ? { id: 'components.reviews.less', defaultMessage: 'Read Less' }
      : { id: 'components.reviews.more', defaultMessage: 'Read More' };

    return (
      <div
        className={`${style.readMore} ${secondaryColorClass}`}
        onClick={this.handleRevealClick}
      >
        <Translation {...messageProps} />
      </div>
    );
  }

  renderStyle() {
    const { page, dimensions } = this.state;

    return {
      top: -1 * page * dimensions.height,
    };
  }

  render() {
    const {
      author, date, body, rating, googleReview,
    } = this.props;
    const reviewDate = getUnixDate(date);

    return (
      <div className={[style.review, body ? null : style.noText].filter(Boolean).join(' ')}>
        <div className={style.quote}>&ldquo;</div>
        <div className={`${style.quote} ${style.right}`}>&rdquo;</div>
        {googleReview ? (
          <img
            src={gIcon}
            alt="google"
            height="16"
            width="16"
            type="image/svg+xml"
          />
        ) : ''}
        <StarRack className={style.starRack} rating={rating} />
        <Measure
          onMeasure={dimensions => this.setState({ dimensions })}
          whitelist={['height']}
        >
          <div className={style.bodyContainer}>
            <div className={style.body} ref={this.registerReviewBody} style={this.renderStyle()}>
              <div className={style.heading}>
                {author}
                {' '}
                <Date
                  day="2-digit"
                  month="2-digit"
                  year="numeric"
                  value={reviewDate}
                >
                  {formattedDate => (
                    <Translation
                      id="components.reviews.date"
                      defaultMessage="on {date}"
                      values={{ date: formattedDate }}
                    >
                      {text => <span className={style.date}>{text}</span>}
                    </Translation>
                  )}
                </Date>
              </div>
              {body}
            </div>
          </div>
        </Measure>
        {this.renderRevealButton()}
      </div>
    );
  }
}

export default pureWithState()(Review);
